import httpUtils from '../../utils/HttpUtils'

class AreaService {

  //取城市区域列表
  async getAreaList (cityId) {
    console.log('获取城市区域列表');
    var result = null;
    try {
      result = await httpUtils.post('/core/area/list',{cityId:cityId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new AreaService()
